__turbopack_context__.v({
  "form": "RMKRFG_form",
  "headline": "RMKRFG_headline",
  "placeholder": "RMKRFG_placeholder",
  "unit": "RMKRFG_unit",
});
